import { render, staticRenderFns } from "./screen3.vue?vue&type=template&id=c6617b94&scoped=true&"
import script from "./screen3.vue?vue&type=script&lang=js&"
export * from "./screen3.vue?vue&type=script&lang=js&"
import style0 from "./screen3.vue?vue&type=style&index=0&id=c6617b94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6617b94",
  null
  
)

export default component.exports